import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=1da35696&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da35696",
  null
  
)

export default component.exports